import api from './api'

export default {
  get() {
    var parm={'from':'ask_an_expert'};
        return api.get('get/ask_an_expert',{params:parm})
  },
  
}
